/* tslint:disable */
/* eslint-disable */
/**
 * api-docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ColumnType = {
    String: 'STRING',
    Number: 'NUMBER',
    Enum: 'ENUM',
    Timestamp: 'TIMESTAMP',
    Boolean: 'BOOLEAN',
};
export function ColumnTypeFromJSON(json) {
    return ColumnTypeFromJSONTyped(json, false);
}
export function ColumnTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ColumnTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=ColumnType.js.map